import React, { useState } from "react";

import api, { handleApi } from "pages/api/api";

import DialogSelecionarMateriais from "./DialogSelecionarMateriais";

import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

export default function CampanhaAlternativasGerais({
  materiaisCombo,
  materialLabel,
  alternativaGeralInput,
  setAlternativaGeralInput,
  formAlternativaGeral,
  setFormAlternativaGeral,
  carregarMateriaisCombo,
  guardarAlternativaGeral,
  alternativasGerais,
  editarAlternativaGeral,
  apagarAlternativaGeral,
  form,
  carregarAlternativasGerais,
  showAlert,
  setLoading,
}) {
  const [openSelecionarVarios, setOpenSelecionarVarios] = useState(false);

  const confirmarSelecionarVarios = async (materiais) => {
    if (!form?.id) {
      showAlert("Grava primeiro o cabeçalho da campanha.", "warning");
      return;
    }

    if (!materiais || materiais.length === 0) {
      showAlert("Seleciona pelo menos um material.", "warning");
      return;
    }

    setLoading(true);

    const [payload, err, meta] = await handleApi(
      api.post("Campanhas/InsCampanhaMaterialAlternativosGeraisLote", {
        idcampanha: form.id,
        materiais: materiais.map((m) => ({
          refmaterialalternativo: m.ref,
          qtd: 0,
          unidade: m.refmaterialunidade || formAlternativaGeral.unidade || "",
          descprommaxfabricante:
            formAlternativaGeral.descprommaxfabricante === ""
              ? null
              : Number(formAlternativaGeral.descprommaxfabricante),
          fatorequivalencia: Number(formAlternativaGeral.fatorequivalencia || 1),
          obs: formAlternativaGeral.obs || "",
        })),
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setOpenSelecionarVarios(false);

    await carregarAlternativasGerais(form.id);

    showAlert(meta?.message || "Alternativas gerais inseridas.", meta?.severity || "success");
  };

  return (
    <MDBox
      mt={2}
      p={{ xs: 1.25, md: 2 }}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <MDTypography variant="h6" mb={1}>
        Alternativas gerais
      </MDTypography>

      <MDBox
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          sm: "1fr 1fr",
          lg: "minmax(260px, 2fr) minmax(130px, 0.8fr) minmax(130px, 0.8fr) minmax(220px, 1.5fr) auto",
        }}
        gap={1}
        mb={2}
        alignItems="flex-end"
        sx={{
          maxWidth: "100%",
          "& .MuiButton-root": {
            width: { xs: "100%", lg: "auto" },
          },
        }}
      >
        <MDBox sx={{ minWidth: 0 }}>
          <MDBox display="flex" gap={1} mb={1.5}>
            <MDButton color="info" onClick={() => setOpenSelecionarVarios(true)}>
              Selecionar vários
            </MDButton>
          </MDBox>

          <Autocomplete
            size="small"
            options={materiaisCombo}
            filterOptions={(x) => x}
            inputValue={alternativaGeralInput}
            getOptionLabel={materialLabel}
            value={
              materiaisCombo.find((m) => m.ref === formAlternativaGeral.refmaterialalternativo) ||
              null
            }
            onInputChange={(_, value, reason) => {
              if (reason === "input") {
                setAlternativaGeralInput(value);

                setFormAlternativaGeral((p) => ({
                  ...p,
                  refmaterialalternativo: "",
                }));

                carregarMateriaisCombo(value);
              }

              if (reason === "clear") {
                setAlternativaGeralInput("");

                setFormAlternativaGeral((p) => ({
                  ...p,
                  refmaterialalternativo: "",
                }));
              }
            }}
            onChange={(_, value) => {
              setFormAlternativaGeral((p) => ({
                ...p,
                refmaterialalternativo: value?.ref || "",
                unidade: value?.refmaterialunidade || "",
              }));

              setAlternativaGeralInput(value ? materialLabel(value) : "");
            }}
            renderInput={(params) => (
              <TextField {...params} label="Material alternativo" placeholder="Pesquisar..." />
            )}
          />
        </MDBox>

        <MDBox sx={{ minWidth: 0 }}>
          <MDInput
            label="Desc. máx. (%)"
            type="number"
            size="small"
            value={formAlternativaGeral.descprommaxfabricante}
            onChange={(e) =>
              setFormAlternativaGeral((p) => ({
                ...p,
                descprommaxfabricante: e.target.value,
              }))
            }
            fullWidth
          />
        </MDBox>

        <MDBox sx={{ minWidth: 0 }}>
          <MDInput
            label="Fator equiv."
            type="number"
            size="small"
            inputProps={{ step: "0.001", min: "0.001" }}
            value={formAlternativaGeral.fatorequivalencia}
            onChange={(e) =>
              setFormAlternativaGeral((p) => ({
                ...p,
                fatorequivalencia: e.target.value,
              }))
            }
            fullWidth
          />
        </MDBox>

        <MDBox sx={{ minWidth: 0 }}>
          <MDInput
            label="Obs"
            size="small"
            value={formAlternativaGeral.obs}
            onChange={(e) =>
              setFormAlternativaGeral((p) => ({
                ...p,
                obs: e.target.value,
              }))
            }
            fullWidth
          />
        </MDBox>

        <MDButton color="success" onClick={guardarAlternativaGeral}>
          {formAlternativaGeral.id ? "Atualizar" : "Adicionar"}
        </MDButton>
      </MDBox>

      <DialogSelecionarMateriais
        open={openSelecionarVarios}
        onClose={() => setOpenSelecionarVarios(false)}
        materiaisCombo={materiaisCombo.filter(
          (m) =>
            !(alternativasGerais || []).some(
              (a) => String(a.refmaterialalternativo) === String(m.ref)
            )
        )}
        carregarMateriaisCombo={carregarMateriaisCombo}
        materialLabel={materialLabel}
        onConfirmar={confirmarSelecionarVarios}
      />

      {alternativasGerais.map((a) => (
        <MDBox
          key={a.id}
          display="grid"
          gridTemplateColumns={{
            xs: "1fr",
            md: "1.2fr 2fr 0.9fr 0.9fr 2fr auto",
          }}
          gap={1.5}
          alignItems="center"
          py={0.5}
          sx={{ borderTop: "1px solid #e0e0e0" }}
        >
          <MDTypography variant="caption">{a.refmaterialalternativo}</MDTypography>

          <MDTypography variant="caption">{a.materialalternativo}</MDTypography>

          <MDTypography variant="caption" sx={{ textAlign: "right" }}>
            {Number(a.fatorequivalencia || 1)
              .toFixed(3)
              .replace(/\.?0+$/, "")}
          </MDTypography>

          <MDTypography variant="caption" sx={{ textAlign: "right" }}>
            {a.descprommaxfabricante != null && a.descprommaxfabricante !== ""
              ? `${a.descprommaxfabricante}%`
              : ""}
          </MDTypography>

          <MDTypography variant="caption">{a.obs}</MDTypography>

          <MDBox display="flex" justifyContent="flex-end" gap={0.5}>
            <IconButton
              size="small"
              color="primary"
              onClick={() => editarAlternativaGeral(a)}
              title="Editar"
            >
              <EditIcon fontSize="small" />
            </IconButton>

            <IconButton
              size="small"
              color="error"
              onClick={() => apagarAlternativaGeral(a)}
              title="Eliminar"
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </MDBox>
        </MDBox>
      ))}
    </MDBox>
  );
}
